<template>
  <div>
    <vuestic-modal ref="openModal"  :large="true">
      <h5 slot="header">{{titulo}}</h5>
      <table class="table table-bordered">
        <thead class="thead-dark">
        <tr>
          <th>Folio</th>
          <th>Fecha</th>
          <th>Us. Envia</th>
          <th>Us. Recep</th>
          <th>Cantidad</th>
          <th>Suc. Origen</th>
          <th>Suc. Destino</th>
          <th>Estado</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="guia in guias">
          <td>{{ guia.folio }}</td>
          <td>{{ guia.fecha }}</td>
          <td>{{ guia.usuario_nombre | upper }}</td>
          <td>{{ guia.nombre_recepcionador | upper }}</td>
          <td>{{ guia.cantidad}}</td>
          <td>{{guia.sucursal_nombre}}</td>
          <td>{{guia.sucursalDestinoNombre}}</td>
          <td>{{guia.estado | upper }}</td>
        </tr>
        </tbody>
      </table>
    </vuestic-modal>
  </div>

</template>
<script>
  import VuesticModal from "../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal";
  import moment from 'moment'
  export default {
    name: 'modalGuias',
    props: ['guias', 'titulo'],
    components: {VuesticModal},
    methods: {
      openModal() {
        this.$refs.openModal.open()
      }
    }
  }
</script>
